<script lang="ts">
  import RadioGroup from "../../../components/RadioGroup.svelte";
  import CloseButton from "../../../components/CloseButton.svelte";
  import { type Component } from "svelte";

  let {
    answer,
    back,
    inactive,
    clientName,
    nextSteps,
  }: {
    answer: ({ nextStep, status }) => void;
    back: () => void;
    inactive: boolean;
    clientName: { [key: string]: string };
    nextSteps: { [key: string]: Component };
  } = $props();

  let selectedOption = $state(null);

  function handleContinue() {
    if (selectedOption === "unchanged") {
      answer({ nextStep: nextSteps.next, status: selectedOption });
    } else if (selectedOption === "changed") {
      answer({ nextStep: nextSteps.name, status: selectedOption });
    } else if (selectedOption === "other_person") {
      answer({ nextStep: nextSteps.other, status: selectedOption });
    }
  }
</script>

<div class="h-full">
  <fieldset class="ui-fieldset">
    <legend>
      <span>
        Did you purchase this vehicle under the name <b>{clientName.firstName} {clientName.lastName}</b>?
      </span>
    </legend>

    <RadioGroup
      name="client_name[status]"
      options={[
        ["Yes", "unchanged"],
        ["No, I used a different name when I purchased this vehicle", "changed"],
        ["No, someone else's name is on the finance agreement", "other_person"],
      ]}
      bind:group={selectedOption}
    />
  </fieldset>
</div>

<div class="floating-footer">
  {#if back}
    <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
  {:else}
    <CloseButton />
  {/if}
  <button
    type="submit"
    class="btn btn-primary"
    onclick={handleContinue}
    disabled={!selectedOption || inactive}>Continue</button
  >
</div>
